module.exports = __webpack_public_path__ + "img/ValidationProf.5413e2bb.svg";